<template>
    <el-dialog v-dialogDrag class="dialog" width="1100px"
               :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                运维受理单
            </div>
        </div>
        <div class="dialog_body">
            <el-container class="mxInfo">
                <el-main style="overflow-y: hidden;padding-bottom: 10px">
                    <div>
                        <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="120px">
                            <div style="padding: 2px;text-align: right">
                                <el-form-item>
                                    <el-button type="danger" icon="el-icon-delete" @click="reload_page()" size="medium">
                                        取消保存
                                    </el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="mdi mdi-content-save" @click="submit()" size="medium">
                                        保存账单
                                    </el-button>
                                </el-form-item>
                            </div>
                            <div>
                                <el-form-item label="处理单号" required>
                                    <el-input style="width:200px" v-model="form.billNo" readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="处理日期" required>
                                    <el-date-picker type="date" placeholder="单据日期"
                                                    style="width: 200px" value-format="yyyy-MM-dd"
                                                    v-model="form.billDate"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="项目名称">
                                    <el-input style="width:200px" v-model="form.projectName" placeholder="请输入项目名称"
                                              @click.native="selProject">
                                    </el-input>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="运维申请单号" required>
                                    <el-input style="width:200px" v-model="form.relaBillNo" readonly
                                              placeholder="请选择运维申请单" @click.native="selBill">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="申请人">
                                    <el-input style="width:200px" v-model="form.applyBy" placeholder="选择运维申请单后自动赋值" readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="申请部门">
                                    <el-input style="width:200px" v-model="form.departmentName" placeholder="选择运维申请单后自动赋值" readonly>
                                    </el-input>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="服务类型">
                                    <el-input style="width:200px" v-model="form.serviceType" placeholder="选择运维申请单后自动赋值" readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="紧急程度">
                                    <el-input style="width:200px" v-model="form.urgencyType" placeholder="选择运维申请单后自动赋值" readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="客户">
                                    <el-input style="width:200px" v-model="form.customerName" placeholder="选择运维申请单后自动赋值" readonly>
                                    </el-input>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="服务地点">
                                    <el-input style="width:200px" v-model="form.serviceAddress" placeholder="选择运维申请单后自动赋值" readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="处理负责人" required>
                                    <el-input style="width:200px" v-model="form.handleBy" placeholder="选择处理负责人"
                                              @click.native="selStaff">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="处理部门" required>
                                    <el-input style="width:200px" v-model="form.departmentNameHandle" placeholder="选择处理部门"  readonly
                                              @click.native="clickDept">
                                    </el-input>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="处理进度" required>
                                    <el-select v-model="form.handleProgress" placeholder="请选择处理进度" style="width: 200px">
                                        <el-option label="进行中" value="进行中"></el-option>
                                        <el-option label="已完成" value="已完成"></el-option>
                                        <el-option label="其他" value="其他"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="预计完成日期" required>
                                    <el-date-picker type="date" placeholder="预计完成日期"
                                                    style="width: 200px" value-format="yyyy-MM-dd"
                                                    v-model="form.completeDate"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="工时合计">
                                    <el-input style="width:200px" v-model="form.workingTotal" placeholder="根据明细自动计算" readonly>
                                    </el-input>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="配件合计">
                                    <el-input style="width:200px" v-model="form.accessoryTotal" placeholder="根据明细自动计算" readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="运维费用合计">
                                    <el-input style="width:200px" v-model="form.feeTotal" placeholder="根据明细自动计算" readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="附件">
                                    <div style="padding: 2px 1px; width: 200px;">
                                        <el-button type="primary" size="medium" icon="el-icon-upload"
                                                   @click="uploadFile">上传
                                        </el-button>
                                        <el-button type="primary" size="medium" icon="el-icon-view" @click="showFile">查看
                                        </el-button>
                                    </div>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="备注">
                                    <el-input style="width:860px"
                                            type="textarea"
                                            placeholder="请输入备注"
                                            v-model="form.remark"
                                            rows="2">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>

                    <el-tabs type="card" style="padding: 2px" v-model="activeName">
                        <el-tab-pane name="first">
                            <span slot="label"><i class="el-icon-date"></i>运维配件信息</span>
                            <div style="padding: 2px;text-align: right">
                                <el-row>
                                    <el-form :inline="true" label-width="120px">
                                        <el-form-item>
                                            <el-button type="warning" icon="el-icon-document" @click="selAccessory()" size="medium">
                                                新增明细
                                            </el-button>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button type="danger" icon="el-icon-delete" @click="delAccessory()" size="medium">
                                                删除明细
                                            </el-button>
                                        </el-form-item>
                                    </el-form>
                                </el-row>
                            </div>
                            <div style="padding-top: 2px" v-loading="loading">
                                <ElTableEdit
                                        height="350"
                                        ref="editTable_Accessory"
                                        :data="dataList_Accessory"
                                        :form="form"
                                        :columns="columns_Accessory"
                                        border
                                        stripe
                                        style="width: 100%"
                                        :header-cell-style="headerStyle"
                                        :cell-style="cellStyle"
                                        :actionsFixed="true"
                                        :actionsWidth="70"
                                        :conf="conf">
                                    <template v-slot:column-actions="{ row, $index }">
                                        <el-button @click="delItem(row, $index,0)"
                                                   type="danger" icon="el-icon-delete" size="small">
                                        </el-button>
                                    </template>
                                </ElTableEdit>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane name="second">
                            <span slot="label"><i class="el-icon-date"></i>运维产品信息</span>
                            <div style="padding: 2px;text-align: right">
                                <el-row>
                                    <el-form :inline="true" label-width="120px">
                                        <el-form-item>
                                            <el-button type="warning" icon="el-icon-document" @click="selProduct" size="medium">
                                                新增明细
                                            </el-button>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button type="danger" icon="el-icon-delete" @click="delProduct" size="medium">
                                                删除明细
                                            </el-button>
                                        </el-form-item>
                                    </el-form>
                                </el-row>
                            </div>
                            <div style="padding-top: 2px" v-loading="loading">
                                <ElTableEdit
                                        height="350"
                                        ref="editTable_Product"
                                        :data="dataList_Product"
                                        :form="form"
                                        :columns="columns_Product"
                                        border
                                        stripe
                                        style="width: 100%"
                                        :header-cell-style="headerStyle"
                                        :cell-style="cellStyle"
                                        :actionsFixed="true"
                                        :actionsWidth="70"
                                        :conf="conf">
                                    <template v-slot:column-actions="{ row, $index }">
                                        <el-button @click="delItem(row, $index,1)"
                                                   type="danger" icon="el-icon-delete" size="small">
                                        </el-button>
                                    </template>
                                </ElTableEdit>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane name="third">
                            <span slot="label"><i class="el-icon-date"></i>派工人员信息</span>
                            <div style="padding: 2px;text-align: right">
                                <el-row>
                                    <el-form :inline="true" label-width="120px">
                                        <el-form-item>
                                            <el-button type="warning" icon="el-icon-document" @click="addPerson" size="medium">
                                                新增明细
                                            </el-button>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button type="danger" icon="el-icon-delete" @click="delPerson" size="medium">
                                                删除明细
                                            </el-button>
                                        </el-form-item>
                                    </el-form>
                                </el-row>
                            </div>
                            <div style="padding-top: 2px" v-loading="loading">
                                <ElTableEdit
                                        height="350"
                                        ref="editTable_Person"
                                        :data="dataList_Person"
                                        :form="form"
                                        :columns="columns_Person"
                                        border
                                        stripe
                                        style="width: 100%"
                                        :header-cell-style="headerStyle"
                                        :cell-style="cellStyle"
                                        :actionsFixed="true"
                                        :actionsWidth="70"
                                        :conf="conf">
                                    <template v-slot:column-actions="{ row, $index }">
                                        <el-button @click="delItem(row, $index,2)"
                                                   type="danger" icon="el-icon-delete" size="small">
                                        </el-button>
                                    </template>
                                </ElTableEdit>
                            </div>
                        </el-tab-pane>
                    </el-tabs>

                </el-main>
            </el-container>
            <selBill v-if="showBill"
                         :selId="selId"
                         :relaBillId="relaBillId"
                         @closeDialog="closeDialog"
                         @checkRow="checkBill">
            </selBill>

            <selDept v-if="showDept"
                     :deptData="deptData"
                     @closeDialog="closeDialog"
                     @checkRow="checkDept">
            </selDept>
            <selProject v-if="showProject"
                        :projectId="projectId"
                        @closeDialog="closeDialog"
                        @checkRow="checkProject">
            </selProject>

            <selProduct v-if="showProduct"
                        :productInfoId="productInfoId"
                        @closeDialog="closeDialog"
                        @checkRow="checkProduct">
            </selProduct>
            <selStaff v-if="showStaff"
                      :staffId="staffId"
                      @closeDialog="closeDialog"
                      @checkRow="checkStaff">
            </selStaff>
            <fileupload v-if="showFileUpload"
                        :fileUrl="fileUrl"
                        :fileParam="fileParam"
                        :fileListUrl="fileListUrl"
                        :delFileUrl="delFileUrl"
                        :fileKey="fileKey"
                        @closeDialog="closeDialog">
            </fileupload>
            <fileDialog v-if="showFileDialog"
                        :fileParam="fileParam"
                        :fileListUrl="fileListUrl"
                        @closeDialog="closeDialog">
            </fileDialog>
        </div>
    </el-dialog>
</template>

<script>
    import fileupload from '@/components/tools/fileupload/dialog'
    import fileDialog from '@/components/tools/fileupload/showDialog'
    import selProject from '@/components/page/project/selProject'
    import selBill from '@/components/page/operations/applyfor/selApplyBill.vue'
    import selStaff from '@/components/rszy/staff/selStaff'
    import selDept from '@/components/rszy/dept/deptSelect/single'
    import ElTableEdit from '@/components/element/el-table-in-edit'
    import selProduct from '@/components/page/wzgl/wzgl/selWzMore'

    import {MessageBox} from "element-ui";

    export default {
        name: "mxInfo",
        props: ['formData'],
        components: {
            fileupload,
            fileDialog,
            selProject,
            selStaff,
            selBill,
            ElTableEdit,
            selProduct,
            selDept
        },
        data() {
            return {
                loading: false,

                activeName: "first",
                form: JSON.parse(JSON.stringify(this.formData)),

                productInfoId: "",
                projectId: "",
                proCode: "",
                proName: "",
                selId:"",
                relaBillId:"",
                selKind:"",
                showDept: false,
                showProduct:false,
                deptData: {},
                showBill:false,
                showProject: false,
                dialogVisible: true,
                dialoading: this.loading,
                showStaff: false,
                staffId: "",

                conf: {},
                columns_Accessory: [
                    {
                        title: "序号",
                        width: "60",
                        key: "_xh",
                        type: "index",
                        fixed: true,
                    },
                    {
                        title: "选择",
                        width: "60",
                        key: "selection",
                        type: "selection",
                        fixed: true,
                    },
                    {
                        title: "设备类别",
                        width: "100",
                        key: "typeName",
                    },
                    {
                        title: "设备编码",
                        width: "100",
                        key: "proCode",
                    },
                    {
                        title: "设备名称",
                        width: "150",
                        key: "proName",
                    },
                    {
                        title: "计量单位",
                        key: "units",
                    },
                    {
                        title: "规格型号",
                        key: "specification",
                    },
                    {
                        title: "颜色",
                        key: "color",
                    },
                    {
                        title: "产地",
                        key: "orgin",
                    },
                    {
                        title: "数量",
                        key: "num",
                        width: "110",
                        edit: true,
                        type: "number",
                        changeLink: true,
                    },
                    {
                        title: "单价",
                        key: "taxPrice",
                        width: "130",
                        edit: true,
                        type: "number",
                        changeLink: true,
                    },
                    {
                        title: "金额",
                        key: "taxTotal",
                        width: "130",
                        type: "number"
                    },
                    {
                        title: "备注",
                        key: "remark",
                        width: "150",
                        edit: true,
                    },
                ],
                columns_Product: [
                    {
                        title: "序号",
                        width: "60",
                        key: "_xh",
                        type: "index",
                        fixed: true,
                    },
                    {
                        title: "选择",
                        width: "60",
                        key: "selection",
                        type: "selection",
                        fixed: true,
                    },
                    {
                        title: "设备类别",
                        width: "100",
                        key: "typeName",
                    },
                    {
                        title: "设备编码",
                        width: "120",
                        key: "proCode",
                    },
                    {
                        title: "设备名称",
                        width: "150",
                        key: "proName",
                    },
                    {
                        title: "计量单位",
                        key: "units",
                    },
                    {
                        title: "规格型号",
                        key: "specification",
                    },
                    {
                        title: "颜色",
                        key: "color",
                    },
                    {
                        title: "产地",
                        key: "orgin",
                    },
                    {
                        title: "应运维数量",
                        key: "num",
                        width: "110",
                        edit: true,
                        type: "number",
                        changeLink: true,
                    },
                    {
                        title: "已运维数量",
                        key: "handledNum",
                        width: "110",
                        edit: true,
                        type: "number",
                        changeLink: true,
                    },
                    {
                        title: "运维费用",
                        key: "handleFee",
                        width: "130",
                        edit: true,
                        type: "number",
                        changeLink: true,
                    },
                    {
                        title: "运维时长",
                        key: "handleHours",
                        width: "130",
                        edit: true,
                        type: "number",
                        changeLink: true,
                    },
                    {
                        title: "运维详情",
                        key: "handleDetails",
                        edit: true,
                        width: "150"
                    },
                    {
                        title: "备注",
                        key: "remark",
                        width: "150",
                        edit: true,
                    },
                ],
                columns_Person: [
                    {
                        title: "序号",
                        width: "60",
                        key: "_xh",
                        type: "index",
                        fixed: true,
                    },
                    {
                        title: "选择",
                        width: "60",
                        key: "selection",
                        type: "selection",
                        fixed: true,
                    },
                    {
                        title: "姓名",
                        width: "120",
                        key: "staffName",
                        edit: true,
                    },
                    {
                        title: "部门",
                        width: "150",
                        key: "departmentName",
                        edit: true,
                    },
                    {
                        title: "工时",
                        width: "110",
                        key: "workingNum",
                        placeholder: "工时",
                        type: "number",
                        edit: true,
                        changeLink: true,
                    },
                    {
                        title: "工时单价",
                        width: "150",
                        key: "workingPrice",
                        placeholder: "工时单价",
                        type: "number",
                        edit: true,
                        changeLink: true,
                    },
                    {
                        title: "工时合计",
                        width: "150",
                        key: "workingTotal",
                        placeholder: "工时合计",
                        type: "number"
                    },
                    {
                        title: "备注",
                        key: "remark",
                        width: "150",
                        edit: true,
                    },
                ],
                dataList_Accessory: [],
                dataList_Product: [],
                dataList_Person: [],
                pageInfo_Accessory: {
                    page: 1,
                    pagesize: 200,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },
                pageInfo_Product: {
                    page: 1,
                    pagesize: 200,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },
                pageInfo_Person: {
                    page: 1,
                    pagesize: 200,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },

                fileUrl: "/billfile/uploadFiles",
                fileListUrl: "/billfile/getBillFile",
                delFileUrl: "/billfile/delete",
                fileKey: "billFileId",
                fileParam: {
                    billId: this.formData.billId
                },
                showFileUpload: false,
                showFileDialog: false,
            }
        },
        watch: {
            formData: {
                handler(val) {
                    this.form = JSON.parse(JSON.stringify(val))
                    this.fileParam = {
                        billId: this.formData.billId
                    }
                },
                deep: true,
            }
        },
        mounted() {
            this.getListData_Accessory();
            this.getListData_Person();
            this.getListData_Product();
        },
        methods: {
            async reload_page() {
                this.form=JSON.parse(JSON.stringify(this.formData));
                this.getListData_Accessory();
                this.getListData_Person();
                this.getListData_Product();
            },
            async getListData_Accessory() {
                if (this.form.billId) {
                    this.loading = true;
                    let param = {
                        url: "/handling/listAccessory",
                        param: {
                            billId: this.form.billId,
                            limit: this.pageInfo_Accessory.pagesize,
                            page: this.pageInfo_Accessory.page
                        }
                    }
                    const data = await this.$store.dispatch('pubMethod', param)
                    if (data.infoCode == "0") {
                        this.dataList_Accessory = data.data.data;
                        this.pageInfo_Accessory.total = data.data.count;
                    }
                    this.dataList_Accessory.map(item => {
                        item._edit = true
                    })
                    this.loading = false;
                }
            },
            async getListData_Person() {
                if (this.form.billId) {
                    this.loading = true;
                    let param = {
                        url: "/handling/listPerson",
                        param: {
                            billId: this.form.billId,
                            limit: this.pageInfo_Person.pagesize,
                            page: this.pageInfo_Person.page
                        }
                    }
                    const data = await this.$store.dispatch('pubMethod', param)
                    if (data.infoCode == "0") {
                        this.dataList_Person = data.data.data;
                        this.pageInfo_Person.total = data.data.count;
                    }
                    this.dataList_Person.map(item => {
                        item._edit = true
                    })
                    this.loading = false;
                }
            },
            async getListData_Product() {
                if (this.form.billId) {
                    this.loading = true;
                    let param = {
                        url: "/handling/listProduct",
                        param: {
                            billId: this.form.billId,
                            limit: this.pageInfo_Product.pagesize,
                            page: this.pageInfo_Product.page
                        }
                    }
                    const data = await this.$store.dispatch('pubMethod', param)
                    if (data.infoCode == "0") {
                        this.dataList_Product = data.data.data;
                        this.pageInfo_Product.total = data.data.count;
                    }
                    this.dataList_Product.map(item => {
                        item._edit = true
                    })
                    this.loading = false;
                }
            },
            selBill() {
                this.relaBillId = this.form.relaBillId;
                this.showBill = true;
            },
            checkBill(row) {
                this.form.projectId = row.projectId;
                this.form.projectName = row.projectName;
                this.form.relaBillId = row.billId;
                this.form.relaBillNo = row.billNo;
                this.form.relaBillDate = row.billDate;
                this.form.customerId = row.customerId;
                this.form.customerName = row.customerName;
                this.form.contactName = row.contactName;
                this.form.contactTel = row.contactTel;
                this.form.applyBy = row.applyBy;
                this.form.departmentName = row.departmentName;
                this.form.serviceType = row.serviceType;
                this.form.urgencyType = row.urgencyType;
                this.form.trafficType = row.trafficType;
                this.form.serviceAddress = row.serviceAddress;
                this.form.serviceContent = row.serviceContent;
                this.form.dispatchBy = row.dispatchBy;
                this.form.departmentNameDispatch = row.departmentNameDispatch;
                this.form.dispatchDate = row.dispatchDate;
                this.showBill = false;

                //获取运维产品和派工人员信息
                this.getApplyFor();
                this.getDispatch();

            },
            async getApplyFor() {
                if (this.form.relaBillId) {
                    this.loading = true;
                    let param = {
                        url: "/applyfor/listProduct",
                        param: {
                            billId: this.form.relaBillId,
                            limit: 500,
                            page: this.pageInfo_Product.page
                        }
                    }
                    const data = await this.$store.dispatch('pubMethod', param)
                    if (data.infoCode == "0") {
                        this.dataList_Product = data.data.data;
                        this.pageInfo_Product.total = data.data.count;
                    }
                    this.dataList_Product.map(item => {
                        item._edit = true
                    })
                    this.loading = false;
                }
            },
            async getDispatch() {
                if (this.form.relaBillId) {
                    this.loading = true;
                    let param = {
                        url: "/dispatch/listBillPerson",
                        param: {
                            relaBillId: this.form.relaBillId,
                            limit: 500,
                            page: this.pageInfo_Person.page
                        }
                    };
                    const data = await this.$store.dispatch('pubMethod', param);
                    if (data.infoCode == "0") {
                        this.dataList_Person = data.data.data;
                        this.pageInfo_Person.total = data.data.count;
                    }
                    this.dataList_Person.map(item => {
                        item._edit = true
                    });
                    this.loading = false;
                }
            },

            checkStaff(row) {
                this.form.handleBy = row.staffName;
                this.showStaff = false;
            },
            selStaff() {
                this.showStaff = true;
            },
            clickDept() {
                this.deptData.id = this.form.departmentIdHandle;
                this.deptData.name = this.form.departmentNameHandle;
                this.showDept = true;
            },
            checkDept(row) {
                this.form.departmentIdHandle = row.id;
                this.form.departmentNameHandle = row.name;
                this.showDept = false;
            },
            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            delProduct() {
                let delData = this.$refs.editTable_Product.getSelection();
                if (delData && delData.length > 0) {
                    MessageBox.confirm('是否确认删除选中的记录, 继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        delData.map(item => {
                            let index = this.dataList_Product.findIndex(list => {
                                if (list.billProId) {
                                    return list.billProId == item.billProId
                                } else {
                                    return list.randomId == item.randomId
                                }
                            })
                            this.dataList_Product.splice(index, 1);
                        })
                        //this.form.billTotal = this.$pub.getBillTotal(this.dataList, this.precisionTotal);
                        this.$refs.editTable_Product.validateRow();
                    }).catch(() => {

                    })

                } else {
                    this.$message.warning("请先选择一条记录");
                }
            },
            delItem(row, index,kind) {
                MessageBox.confirm('是否确认删除该记录, 继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {

                    switch (kind) {
                        case 0:
                            this.dataList_Accessory.splice(index, 1);
                            this.$refs.editTable_Accessory.validateRow();
                            break;
                        case 1:
                            this.dataList_Product.splice(index, 1);
                            this.$refs.editTable_Product.validateRow();
                            break;
                        case 2:
                            this.dataList_Person.splice(index, 1);
                            this.$refs.editTable_Person.validateRow();
                            break;
                    }
                }).catch(() => {

                })
            },
            checkProduct(rows) {
                rows.map(item => {
                    item.randomId = Math.random();
                    item._edit = true;

                    item.num = 1;
                    item.taxPrice = 0;
                    item.taxTotal = 0;
                    item.handledNum = 0;
                    item.handleFee = 0;
                    item.handleHours = 0;
                    item.handleDetails = "";
                    item.remark = "";
                })
                if(this.selKind==1) {
                    this.dataList_Product = this.dataList_Product.concat(rows);
                }else{
                    this.dataList_Accessory = this.dataList_Accessory.concat(rows);
                }
                this.showProduct = false;
            },
            selProduct() {
                this.selKind = 1;
                this.showProduct = true;
            },
            delAccessory() {
                let delData = this.$refs.editTable_Accessory.getSelection();
                if (delData && delData.length > 0) {
                    MessageBox.confirm('是否确认删除选中的记录, 继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        delData.map(item => {
                            let index = this.dataList_Accessory.findIndex(list => {
                                if (list.billProId) {
                                    return list.billProId == item.billProId
                                } else {
                                    return list.randomId == item.randomId
                                }
                            })
                            this.dataList_Accessory.splice(index, 1);
                        })
                        //this.form.billTotal = this.$pub.getBillTotal(this.dataList, this.precisionTotal);
                        this.$refs.editTable_Accessory.validateRow();
                    }).catch(() => {

                    })

                } else {
                    this.$message.warning("请先选择一条记录");
                }
            },
            selAccessory() {
                this.selKind = 0;
                this.showProduct = true;
            },
            delPerson() {
                let delData = this.$refs.editTable_Person.getSelection();
                if (delData && delData.length > 0) {
                    MessageBox.confirm('是否确认删除选中的记录, 继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        delData.map(item => {
                            let index = this.dataList_Person.findIndex(list => {
                                if (list.billProId) {
                                    return list.billProId == item.billProId
                                } else {
                                    return list.randomId == item.randomId
                                }
                            })
                            this.dataList_Person.splice(index, 1);
                        })
                        this.$refs.editTable_Person.validateRow();
                    }).catch(() => {

                    })
                } else {
                    this.$message.warning("请先选择一条记录");
                }
            },
            addPerson() {
                let newRow = {
                    staffName: '',
                    departmentName: '',
                    workingNum: 1,
                    workingPrice: 0,
                    workingTotal: 0,
                    remark: '',
                    _edit: true
                }
                this.dataList_Person = this.dataList_Person.concat(newRow);
            },
            async submit() {
                if (this.$pub.isEmpty(this.form.relaBillNo)) {
                    this.$message({message: '请选择运维申请单', type: 'error'});
                    return false;
                }

                //派工人员信息
                if (this.dataList_Person.length <= 0) {
                    this.$message({message: '请选择派工人员信息', type: 'error'});
                    return false;
                }
                for (let i = 0; i < this.dataList_Person.length; i++) {

                    let staffName = this.dataList_Person[i].staffName;
                    let workingNum = this.dataList_Person[i].workingNum;
                    let workingPrice = this.dataList_Person[i].workingPrice;

                    if (this.$pub.isEmpty(staffName )){
                        this.$message({message: '员工不能为空', type: 'error'});
                        return false;
                    }

                    if (this.$pub.isEmpty(workingNum ) || this.$pub.isEmpty(workingPrice)) {
                        this.$message({message: '工时和工时单价不能为空', type: 'error'});
                        return false;
                    }

                    if (parseFloat(workingNum) <= 0 || parseFloat(workingPrice) < 0) {
                        this.$message({message: '工时和工时单价不能小于等于0', type: 'error'});
                        return false;
                    }

                    this.dataList_Person[i].orderBy = i + 1;
                }

                //运维产品信息
                if (this.dataList_Product.length <= 0) {
                    this.$message({message: '请选择运维产品信息', type: 'error'});
                    return false;
                }
                for (let i = 0; i < this.dataList_Product.length; i++) {

                    let proName = this.dataList_Product[i].proName;
                    let num = this.dataList_Product[i].num;
                    let operationFee = this.dataList_Product[i].operationFee;

                    if (this.$pub.isEmpty(num)) {
                        this.$message({message: '(' + proName + ')数量不能为空', type: 'error'});
                        return false;
                    }

                    if (parseFloat(num) <= 0 || parseFloat(operationFee) <= 0  ) {
                        this.$message({message: '(' + proName + ')数量或运维奋勇不能小于等于0', type: 'error'});
                        return false;
                    }

                    this.dataList_Product[i].orderBy = i + 1;
                }

                //运维配件信息
                if (this.dataList_Accessory.length <= 0) {
                    this.$message({message: '请选择运维产品信息', type: 'error'});
                    return false;
                }
                for (let i = 0; i < this.dataList_Accessory.length; i++) {

                    let proName = this.dataList_Accessory[i].proName;
                    let num = this.dataList_Accessory[i].num;
                    let taxPrice = this.dataList_Accessory[i].taxPrice;

                    if (this.$pub.isEmpty(num)) {
                        this.$message({message: '(' + proName + ')数量不能为空', type: 'error'});
                        return false;
                    }

                    if (parseFloat(num) <= 0 || parseFloat(taxPrice) < 0  ) {
                        this.$message({message: '(' + proName + ')数量或单价不能小于等于0', type: 'error'});
                        return false;
                    }

                    this.dataList_Accessory[i].orderBy = i + 1;
                }

                this.form.handlingAccessoryList = this.dataList_Accessory;
                this.form.handlingProductList = this.dataList_Product;
                this.form.handlingPersonList = this.dataList_Person;

                if (this.$pub.isEmpty(this.form.billDate)) {
                    this.$message({message: '请选择账单日期', type: 'error'});
                    return false;
                } else {
                     /*let billDate = this.form.billDate;
                    let MonthStart = this.$store.state.loginInfo.MonthStart;
                    let MonthEnd = this.$store.state.loginInfo.MonthEnd;
                    if (billDate < MonthStart || billDate > MonthEnd) {
                        this.$message({message: '账单日期不在记账期间内', type: 'error'});
                        return false;
                    }*/
                }
                let param = {
                    ...this.form,
                }
                const data = await this.$sqlOpt.save.save(param, "/handling/save");
                if (data.infoCode === '0') {
                    this.$message.success("操作成功");
                    this.$emit('closeDialog', this.dialogVisible);
                }
                this.loading = false;
            },
            selProject() {
                this.projectId = this.form.projectId;
                this.showProject = true;
            },
            checkProject(row) {
                this.form.projectId = row.projectId;
                this.form.projectName = row.projectName;
                this.showProject = false;
            },
            closeDialog() {
                this.showFileUpload = false;
                this.showFileDialog = false;
                this.showDept = false;
                this.showProject = false;
                this.showStaff = false;
                this.showBill = false;
            },
            uploadFile() {
                this.showFileUpload = true;
            },
            showFile() {
                this.showFileDialog = true;
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
        }
    }
</script>
<!--

-->
